import { Button } from '@/components/ui/button';
import { type ReactNode } from 'react';

export interface TableErrorStateProps {
  refetchAction?: () => void;
  message?: ReactNode;
}

export function TableErrorState({ message, refetchAction }: TableErrorStateProps) {
  const errorMessage = message ?? <div>There was an error loading data. Please try again.</div>;

  return (
    <div className="min-h-[100px] flex items-center justify-center flex-col gap-2">
      {errorMessage}
      {refetchAction && (
        <Button type="button" onClick={refetchAction} variant="outline">
          Retry
        </Button>
      )}
    </div>
  );
}
